import React from 'react';
import { getCookieByName } from '../utils/functions';

export const useFlowName = (config: any) => {
  const flowNameCookie = getCookieByName('flowName', false);
  const flowName = config?.flowName;
  const searchParams = new URLSearchParams(window.location.search);

  for (const [key, value] of searchParams) {
    if (key === 'flowName') {
      return value;
    }
  }

  if (flowNameCookie !== null && flowNameCookie !== undefined) {
    return flowNameCookie as string;
  }
  if (flowName !== null && flowName !== undefined) {
    return flowName as string;
  }
  return '';
};
